var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightEmergencyOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4C11.25 4.41421 11.5858 4.75 12 4.75C12.4142 4.75 12.75 4.41421 12.75 4V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.90899 2.90912C3.6161 2.61623 3.14122 2.61623 2.84833 2.90912C2.55544 3.20202 2.55544 3.67689 2.84833 3.96978L4.96965 6.0911C5.26254 6.384 5.73742 6.384 6.03031 6.0911C6.3232 5.79821 6.3232 5.32334 6.03031 5.03044L3.90899 2.90912Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0303 2.90912C20.7374 2.61623 20.2626 2.61623 19.9697 2.90912L17.8484 5.03044C17.5555 5.32334 17.5555 5.79821 17.8484 6.0911C18.1412 6.384 18.6161 6.384 18.909 6.0911L21.0303 3.96978C21.3232 3.67689 21.3232 3.20202 21.0303 2.90912Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15C3 10.0294 7.02944 6 12 6C16.9706 6 21 10.0294 21 15V21.25H22C22.4142 21.25 22.75 21.5858 22.75 22C22.75 22.4142 22.4142 22.75 22 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22C1.25 21.5858 1.58579 21.25 2 21.25H3V15ZM12.75 16.8546C13.483 16.5579 14 15.8393 14 15C14 13.8954 13.1046 13 12 13C10.8954 13 10 13.8954 10 15C10 15.8393 10.517 16.5579 11.25 16.8546V21.25H12.75V16.8546Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightEmergencyOn);
export default __webpack_public_path__ + "static/media/light-emergency-on.0f22e30d5fddbd5198aa83c704d24535.svg";
export { ForwardRef as ReactComponent };